// Utility functions for handling redirects from email links

/**
 * Store the intended URL that user tried to access before login
 * @param {string} url - The URL to store
 */
export const storeRedirectUrl = (url) => {
  if (url && url !== '/' && url !== '/login') {
    localStorage.setItem('redirect_after_login', url);
  }
};

/**
 * Get the stored redirect URL and clear it
 * @returns {string|null} - The stored URL or null
 */
export const getAndClearRedirectUrl = () => {
  const url = localStorage.getItem('redirect_after_login');
  if (url) {
    localStorage.removeItem('redirect_after_login');
    return url;
  }
  return null;
};

/**
 * Check if a URL is a public route that doesn't require authentication
 * @param {string} pathname - The pathname to check
 * @returns {boolean} - True if it's a public route
 */
export const isPublicRoute = (pathname) => {
  const publicRoutes = [
    '/',
    '/changePassword',
    '/complete-signup',
    '/registration',
    '/employee-id',
    '/public-employee'
  ];
  
  return publicRoutes.some(route => {
    if (route === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(route);
  });
};

/**
 * Check if current URL is an email redirect by looking for source parameter
 * @param {URLSearchParams} searchParams - URL search parameters
 * @returns {boolean} - True if it's from email
 */
export const isEmailRedirect = (searchParams) => {
  return searchParams.get('source') === 'email';
};